// Организационно-правовая форма участника перевозки.
//
// Значения кириллицей — такими их принимает бэкенд
// (Entity\Shipment\ValueObject\PersonType) и такими они уходят в XML накладной
// по формату ФНС: ЮЛ — блок СвЮЛУч, ИП — СвИП, ФЛ — СвФЛУч. Пустой тип бэкенд
// трактует как юридическое лицо, поэтому его можно не отправлять вовсе.
export const PERSON_TYPES = Object.freeze({
  legalEntity: 'ЮЛ',
  individualEntrepreneur: 'ИП',
  individual: 'ФЛ',
});

export const PERSON_TYPE_KEYS = Object.freeze(Object.keys(PERSON_TYPES));

const RUSSIA = 'RU';

export function isRussianPerson (person) {
  return String(person?.country || '').toUpperCase() === RUSSIA;
}

// Тип, который реально уходит в запрос и определяет вид формы.
export function getEffectivePersonType (person) {
  return person?.eawbDisabled ? '' : (person?.type || '');
}

// ФИО заполняется у ИП и физлица.
const INDIVIDUAL_TYPES = Object.freeze([
  PERSON_TYPES.individualEntrepreneur,
  PERSON_TYPES.individual,
]);

export function isIndividualPersonType (type) {
  return INDIVIDUAL_TYPES.includes(type);
}

// ИНН: 10 цифр у организации, 12 у ИП и физлица. Бэкенд сверяет длину только
// для России (PersonaValidator), в остальных странах формат свой.
export function getPersonInnLength (type) {
  return isIndividualPersonType(type) ? 12 : 10;
}

// Своё наименование есть у организации и у ИП — там же работает поиск по ИНН.
// У физлица его нет вовсе, но непустым бэкенд требует поле для любого типа,
// поэтому наименование собирается из ФИО.
export function hasOwnPersonName (type) {
  return type !== PERSON_TYPES.individual;
}

export function createPersonIndividual (source = {}) {
  const individual = source || {};
  return {
    surname: individual.surname || '',
    name: individual.name || '',
    patronymic: individual.patronymic || '',
  };
}

// Отчество необязательно, но пустую строку бэкенд запишет в ФИО пустым
// атрибутом — отправляем null. Пробелы срезаем, чтобы ФИО в запросе совпадало
// с наименованием, собранным composePersonName().
export function buildPersonIndividual (source) {
  const { surname, name, patronymic } = createPersonIndividual(source);
  return {
    surname: surname.trim(),
    name: name.trim(),
    patronymic: patronymic.trim() || null,
  };
}

// Наименование физлица — это его ФИО, см. hasOwnPersonName().
export function composePersonName (source) {
  const { surname, name, patronymic } = createPersonIndividual(source);
  return [surname, name, patronymic]
    .map(part => part.trim())
    .filter(Boolean)
    .join(' ');
}
